import { render, staticRenderFns } from "./route-notification.vue?vue&type=template&id=39367868&scoped=true&"
import script from "./route-notification.vue?vue&type=script&lang=js&"
export * from "./route-notification.vue?vue&type=script&lang=js&"
import style0 from "./route-notification.vue?vue&type=style&index=0&id=39367868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39367868",
  null
  
)

export default component.exports